<div class="dashboard-container p-3">
  <div class="team-add-container d-flex flex-column align-items-center justify-content-center border-one border-light-4-gray bg-light-1-gray w-100 gap-2 p-2">
    <div class="team-icon" [innerHtml]="ICONS.TEAM_ICON('var(--gray-light-4)', 24, 24) | sanitizer: 'html'"></div>
    <div class="fs-16 fw-bold">Add Team Members</div>
    <div class="fs-14 fw-medium text-center text-dark-4-gray">Collaborate effortlessly and enhance productivity with your team.</div>
    <button class="btn-md-filled-primary fw-bold justify-content-center" matRipple [routerLink]="['/team']">
      <mat-icon class="text-white fs-20 mt-1"> add_circle_outlined </mat-icon>
      Add Member
    </button>
  </div>
</div>
